import React, { useState, useEffect, useRef } from 'react'
import DashBoardTable from '../ProGridTable/DashBoardTable';
import { getApi } from '../../../../utils/services'
import { PARTNER_RISK_GAUGE_DATA } from '../../../../utils/services/apiPath'
import { errorToast } from '../../../../utils/toastHelper';


const PartnerRisk = ({ selectedProjectsQuery }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const hasFetchedData = useRef(false);
  const columns = [
    { field: "projectName", headerName: "Project" },
    { field: "partnerName", headerName: "Partner Name" },
    { field: "documentationRiskLevel", headerName: "Documentation Risk Level" },
    { field: "prevailingWageRiskLevel", headerName: "Prevailing Wage Risk Level" },
    { field: "journeyToApprenticeRiskLevel", headerName: "J to A Risk Level" },
  ];

  const fetchPartnerRiskData = async () => {
    try {
      setLoading(true);
      const { data } = await getApi(`${PARTNER_RISK_GAUGE_DATA}?projectIds=${selectedProjectsQuery}`);

      const rowsWithId = data.map((item, index) => ({
        id: `row-${index}`,
        projectName: item.projectName,
        partnerName: item.partnerName,
        documentationRiskLevel: item.documentationRiskLevel,
        prevailingWageRiskLevel: item.prevailingWageRiskLevel,
        journeyToApprenticeRiskLevel: item.journeyToApprenticeRiskLevel,
      }));
      setRows(rowsWithId);
      setLoading(false);
    } catch (error) {
      errorToast(error)
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!hasFetchedData.current) {
      hasFetchedData.current = true;
      fetchPartnerRiskData();
    }
  }, [selectedProjectsQuery]);
  return (
    <div style={{ marginTop: "20px" }}>
      <DashBoardTable
        columns={columns}
        rows={rows}
        loading={loading}
        paginationModel={{ page: 0, pageSize: 5 }}
        hideExport={false}
        checkboxSelection={false}
      />
    </div>
  )
}

export default PartnerRisk